import commonZhHK from './common_zh-HK'

const fsZhHK = {
  fs: {
    ...commonZhHK,
  }
}

export default fsZhHK